// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".balloon{display:flex;justify-content:center;align-items:center;position:fixed;right:10px;bottom:70px;height:50px;width:50px;background-color:#25d366;z-index:100000000000;border-radius:40px;cursor:pointer}", ""]);
// Exports
module.exports = exports;
